/**
 * 환경변수 접근 지점
 * - 누락된 값은 앱 부팅 시점에 즉시 실패하도록 검증한다.
 */
function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const PRODUCT_TITLE = getRequiredEnv("VITE_PRODUCT_TITLE");
export const PRODUCT_VERSION = getRequiredEnv("VITE_PRODUCT_VERSION");
export const API_HOST = getRequiredEnv("VITE_BASE_API_URL");
export const DATE_FORMAT_STRING = getRequiredEnv("VITE_DATE_FORMAT_STRING");
export const DATETIME_SECONDS_FORMAT_STRING = getRequiredEnv(
  "VITE_DATETIME_SECONDS_FORMAT_STRING",
);
export const TIME_SECONDS_FORMAT_STRING = getRequiredEnv(
  "VITE_TIME_SECONDS_FORMAT_STRING",
);
export const DATETIME_FORMAT_STRING = getRequiredEnv(
  "VITE_DATETIME_FORMAT_STRING",
);
export const TIME_FORMAT_STRING = getRequiredEnv("VITE_TIME_FORMAT_STRING");
export const ENVIRONMENT = getRequiredEnv("VITE_ENVIRONMENT");
// DSN 은 선택값이다 — 관측 도구 설정 하나가 서비스(공개 링크 포함) 가용성을 막지 않게 한다(30차 P30-05). 비면 Sentry 초기화를 건너뛴다.
export const SENTRY_DSN: string =
  (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "";
